import type {SelectPaymentMethodInterface} from "~/constants/values/payment/payment";
import {PAYMENT_CARD, PAYMENT_LEGAL_ENTITY} from "~/constants/values/payment/payment";

export function validatePayment(selectedPaymentMethod:SelectPaymentMethodInterface, countCards:number|null = null):{validation:boolean, message?:string} {
    const { t } = useNuxtApp().$i18n

    switch (selectedPaymentMethod.method) {
        case PAYMENT_LEGAL_ENTITY:
            if(!selectedPaymentMethod.value){
                return {
                    validation: false,
                    message: t('validation.required.fill').replace(':attribute', t('order_product.payment_method.legal_entity'))
                }
            }
            return {
                validation: true
            }
        case PAYMENT_CARD:
            if(countCards && !selectedPaymentMethod.value && (!selectedPaymentMethod.options?.newCard??true)){
                return {
                    validation: false,
                    message: t('validation.required.fill').replace(':attribute', t('order_product.payment_method.card'))
                }
            }
            return {
                validation: true
            }
        default:
            return {
                validation: true
            }
    }
}